
    <div
        class="form-group"
        [ngClass]="{'has-error': isInvalid()}">
      <label class="col-lg-3 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
        <i *ngIf="getHint()" class="fa fa-info-circle"
           tooltip="{{getHint()|translate}}"
           placement="top"
           triggers="click"
           containerClass="tig-tooltip"
           delay="50"></i>
        <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
      <div class="col-lg-8">
        <tig-multiselect
            [items]="OBJ_field_config.options"
            [settings]="OBJ_settings"
            [disabled]="OBJ_field_config?.readonly"
            [(ngModel)]="OBJ_data.ids"
        ></tig-multiselect>
        <span class="help-block m-b-none" *ngIf="isInvalid()">
		  {{'oError.sRequired'|translate}}
		</span>
      </div>
    </div>
	